import { Team } from '@ori/testid-generator';

/**
 * Identity server client ID for authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';

/**
 * Name of this app.
 */
export const APP_NAME = 'back-in-stock-notification-spa';

/**
 * Team which owns this SPA.
 */
export const APP_TEAM_NAME: Team = Team.Presentation;

/**
 * Key used to store the emotion cache in local storage.
 */

export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;

/**
 * Serves as identifier to the root of this SPA in the HTML:
 */
export const APP_ROOT_ELEMENT_ID = 'online-back-in-stock-notification-root';
